import { cloneDeep, unionBy } from 'lodash'
import { linkCores } from './link'
import { process } from './node'
import { tick } from './tick'
import * as dictionaries from './dictionaries'

export const nodes = (): array => {
  return globalThis._STORAGE_.nodes
}

export const links = (): array => {
  return globalThis._STORAGE_.links
}

export const patch = (newNodes: array, newLinks: array): object => {
  const nodesChanged = patchNodes(newNodes)
  const linksChanged = patchLinks(newLinks)
  return { nodesChanged, linksChanged }
}

export const images = (tuples: array): object => {
  tuples.forEach(tuple => {
    if (globalThis._IMAGES_[tuple.nodeId] === undefined) {
      const image = new Image()
      image.src = tuple.url
      image.crossOrigin = 'anonymous'
      image.onload = () => {
        tick()
      }
      globalThis._IMAGES_[tuple.nodeId] = image
    }
  })
}

export const pillTexts = (tuples: array): object => {
  tuples.forEach(tuple => {
    if (globalThis._NEIGHBOR_PILL_TEXTS_[tuple.nodeId] === undefined) {
      globalThis._NEIGHBOR_PILL_TEXTS_[tuple.nodeId] = tuple.neighborPillText
    }
  })
}

const patchNodes = (newNodes: array): boolean => {
  const diffedNodes = newNodes.filter(node => nodeIds().includes(node.id) === false)
  if (diffedNodes.length === 0) return false
  const unitedNodes = uniteNodes(process(diffedNodes))
  setNodes(unitedNodes)
  dictionaries.create(nodes())
  return true
}

const patchLinks = (newLinks: array): boolean => {
  const diffedLinks = newLinks.filter(link => linkIds().includes(link.id) === false)
  if (diffedLinks.length === 0) return false
  const unitedLinks = uniteLinks(diffedLinks)
  const processedLinks = linkCores(nodes(), unitedLinks)
  setLinks(processedLinks)
  return true
}

const uniteNodes = (newNodes: array): array => {
  const currentNodes = cloneDeep(nodes())
  return unionBy(currentNodes, newNodes, 'id')
}

const uniteLinks = (newLinks: array): array => {
  const currentLinks = cloneDeep(links())
  currentLinks.forEach(link => {
    link.source = link.source.id
    link.target = link.target.id
  })
  return unionBy(currentLinks, newLinks, 'id')
}

const setNodes = (newNodes: array): void => {
  if (newNodes.length === 0) return
  setNodeIds(newNodes)
  globalThis._STORAGE_.nodes = newNodes
}

const setLinks = (newLinks: array): void => {
  if (newLinks.length === 0) return
  setLinkIds(newLinks)
  globalThis._STORAGE_.links = newLinks
}

const nodeIds = (): array => {
  return globalThis._STORAGE_.nodeIds
}

const linkIds = (): array => {
  return globalThis._STORAGE_.linkIds
}

const setNodeIds = (newNodes: array): void => {
  globalThis._STORAGE_.nodeIds = newNodes.map(node => node.id)
}

const setLinkIds = (newLinks: array): void => {
  globalThis._STORAGE_.linkIds = newLinks.map(link => link.id)
}
